import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TtsControlEnum} from 'app/core/enums/tts-control.enum';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-basic-header',
    templateUrl: './basic-display-consent-header.component.html',
    styleUrls: ['./basic-display-consent-header.component.scss']
})
export class BasicDisplayConsentHeaderComponent {

    @Input() informationUnitTitle: string;
    @Input() actionButtonText: string | undefined;
    @Input() leaveButtonLabel: string;
    @Input() submittedConsentId?: string;
    @Input() stopAudio: Observable<void> = new Observable<void>();
    @Input() indicationName: string | undefined;
    @Input() ttsIconState: TtsControlEnum | undefined;
    @Output() buttonEvent: EventEmitter<string> = new EventEmitter();
    @Output() playFromStartAudioEvent: EventEmitter<void> = new EventEmitter();
    @Output() pauseAudioEvent: EventEmitter<void> = new EventEmitter();
    @Output() leaveIndication: EventEmitter<void> = new EventEmitter();
    @Output() readTextEvent: EventEmitter<void> = new EventEmitter();
    playState = TtsControlEnum.playState;

    readText(): void {
        this.readTextEvent.emit();
    }
}
